import { useState } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { usePatientData } from '../../hooks/usePatientData'
import Hoy from './Hoy'
import Progreso from './Progreso'
import Perfil from './Perfil'
import { T, fonts } from '../../styles/theme'

const NAV = [
  { key: 'hoy', icon: '🏠', label: 'Hoy' },
  { key: 'progreso', icon: '📊', label: 'Progreso' },
  { key: 'perfil', icon: '⚙️', label: 'Perfil' },
]

export default function PatientApp() {
  const { user, signOut } = useAuth()
  const data = usePatientData(user?.id)
  const [tab, setTab] = useState('hoy')

  if (data.loading) return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.accent, fontFamily: 'DM Sans, sans-serif' }}>
      Cargando...
    </div>
  )

  return (
    <>
      <style>{`
        ${fonts}
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: ${T.bg}; font-family: 'DM Sans', sans-serif; }
        ::-webkit-scrollbar { width: 3px; }
        ::-webkit-scrollbar-thumb { background: ${T.cardB}; border-radius: 2px; }
      `}</style>
      <div style={{ maxWidth: 390, margin: '0 auto', minHeight: '100vh', background: T.bg }}>
        <div style={{ paddingBottom: 80, minHeight: '100vh' }}>
          {tab === 'hoy' && <Hoy data={data} />}
          {tab === 'progreso' && <Progreso data={data} />}
          {tab === 'perfil' && <Perfil data={data} signOut={signOut} />}
        </div>

        <nav style={{
          position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
          width: 390, maxWidth: '100%', background: 'rgba(26,29,39,0.96)',
          backdropFilter: 'blur(12px)', borderTop: `1px solid ${T.cardB}`,
          display: 'flex', padding: '8px 0 20px', zIndex: 30
        }}>
          {NAV.map(({ key, icon, label }) => (
            <div key={key} onClick={() => setTab(key)} style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 3, cursor: 'pointer', padding: '6px 0'
            }}>
              <span style={{ fontSize: 20 }}>{icon}</span>
              <span style={{ fontSize: 10, fontWeight: 500, color: tab === key ? T.accent : T.muted }}>{label}</span>
              {tab === key && <div style={{ width: 4, height: 4, borderRadius: 2, background: T.accent }} />}
            </div>
          ))}
        </nav>
      </div>
    </>
  )
}